/* Halune — small, dependency-free enhancements. Every feature degrades to plain HTML forms and links. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Header: transparent only while it sits over a full-height hero at the top of the page. */
  function initHeader() {
    var header = $('[data-hl-header]');
    if (!header) return;
    var main = document.getElementById('MainContent');
    var first = main && main.querySelector('.shopify-section');
    var hero = first && first.querySelector('[data-hl-hero="full"], [data-hl-hero="large"]');
    if (!hero) return;
    var menu = $('[data-hl-menu]');
    function update() {
      var over = window.scrollY < Math.max(40, hero.offsetHeight - header.offsetHeight - 20);
      header.classList.toggle('is-overlay', over && !(menu && menu.open));
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (menu) menu.addEventListener('toggle', update);
  }

  /* Mobile menu: lock scroll while open, close with Escape or on link click. */
  function initMenu() {
    var menu = $('[data-hl-menu]');
    if (!menu) return;
    var header = $('[data-hl-header]');
    menu.addEventListener('toggle', function () {
      document.documentElement.classList.toggle('hl-lock', menu.open);
      if (header) header.classList.toggle('is-menu', menu.open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
    });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { menu.open = false; }); });
  }

  /* Reveal on scroll. */
  function initReveal() {
    var els = $$('[data-hl-reveal]');
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Product gallery thumbnails. */
  function initGallery() {
    var g = $('[data-hl-gallery]');
    if (!g) return;
    var track = $('[data-hl-track]', g);
    var thumbs = $$('[data-hl-thumb]', g);
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.getAttribute('data-hl-thumb');
        track.scrollTo({ left: track.clientWidth * i, behavior: reduced ? 'auto' : 'smooth' });
      });
    });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }, 60);
    }, { passive: true });
  }

  /* Kit configurator. Radios carry real variant ids; this only syncs the logo variant and the summary. */
  function initConfigurator() {
    var form = $('[data-hl-config]');
    var dataEl = $('[data-hl-kits]');
    if (!form || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var radios = $$('input[name="id"]', form);
    var logo = $('[data-hl-logo]', form);
    var logoSwitch = $('[data-hl-logo-switch]', form);
    var logoNote = $('[data-hl-logo-note]', form);
    var quote = $('[data-hl-quote]', form);

    function set(field, value) { $$('[data-hl-f="' + field + '"]').forEach(function (el) { el.textContent = value; }); }

    function update(pushUrl) {
      var r = radios.filter(function (x) { return x.checked; })[0];
      if (!r) return;
      var lamps = r.getAttribute('data-hl-lamps');
      var k = data.kits[lamps];
      if (!k) return;
      var eligible = !!k.logoId && +lamps >= data.logoMin;
      if (logoSwitch) logoSwitch.hidden = !eligible;
      if (logoNote) logoNote.hidden = eligible;
      var withLogo = eligible && logo && logo.checked;
      radios.forEach(function (x) {
        var kk = data.kits[x.getAttribute('data-hl-lamps')];
        if (kk) x.value = (x === r && withLogo) ? kk.logoId : kk.id;
      });
      set('kit', lamps + ' lamps');
      set('stations', k.stations);
      set('trial', k.trial);
      set('logo', withLogo ? k.logoExtra : (eligible ? 'Not selected' : 'From ' + data.logoMin + ' lamps'));
      set('prep', withLogo && k.logoPrep ? k.logoPrep : k.prep);
      set('transit', k.transit);
      set('credit', k.credit);
      set('price', withLogo ? k.logoPrice : k.price);
      if (quote) quote.href = quote.href.split('?')[0] + '?kit=' + lamps + (withLogo ? '&logo=1' : '');
      if (pushUrl && window.history && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set('variant', r.value);
        history.replaceState(null, '', u.toString());
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { update(true); }); });
    if (logo) logo.addEventListener('change', function () { update(true); });
    update(false);

    /* Sticky mobile bar: shown whenever the main button is off screen (above or below). */
    var bar = $('[data-hl-sticky]');
    var add = $('[data-hl-add]', form);
    if (bar && add && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting;
        bar.classList.toggle('is-on', show);
        document.body.classList.toggle('hl-has-sticky', show);
      }).observe(add);
    }
  }

  /* Table sizer (V3): one lamp per table, one station per 25 lamps, prices from the shared pricing module. */
  function initSizer() {
    var box = $('[data-hl-sizer]');
    if (!box) return;
    if (!window.HalunePricing) { document.addEventListener('DOMContentLoaded', initSizer, { once: true }); return; }
    var cfg = null;
    try { cfg = JSON.parse($('[data-hl-pricing]', box.parentNode.parentNode).textContent); } catch (e) {}
    var input = $('[data-hl-tables]', box), errEl = $('[data-hl-tables-err]', box);
    var outLamps = $('[data-hl-out-lamps]', box), outStations = $('[data-hl-out-stations]', box), outPrice = $('[data-hl-out-price]', box), outLink = $('[data-hl-out-link]', box);
    var build = box.getAttribute('data-build') || '/products/restaurant-kit', quoteUrl = box.getAttribute('data-quote') || '/pages/request-a-quote';
    function money(c) { return (c / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: c % 100 ? 2 : 0 }); }
    function render() {
      var raw = String(input.value).trim();
      var n = /^\d+$/.test(raw) ? parseInt(raw, 10) : NaN;
      var bad = !(n >= 1 && n <= 10000);
      errEl.textContent = bad ? 'Enter a whole number of tables from 1 to 10,000.' : '';
      input.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (bad) return;
      var stations = Math.ceil(n / 25);
      outLamps.textContent = n === 1 ? '1 lamp' : n.toLocaleString('en-US') + ' lamps';
      outStations.textContent = stations === 1 ? '1 station for one charging batch' : stations.toLocaleString('en-US') + ' stations for one charging batch';
      var p = cfg ? window.HalunePricing.priceConfig(cfg, { lamps: n, stations: stations }) : null;
      if (p && p.ok && p.status !== 'quote_required') outPrice.textContent = money(p.lampCents) + ' for the lamps (' + money(p.averageLampCents) + ' on average) + ' + money(p.stationCents) + ' for the stations = ' + money(p.totalCents) + '. Shipping included.';
      else outPrice.textContent = 'From 1,000 lamps, we confirm the price in a written quote.';
      if (p && p.status === 'availability_request') outPrice.textContent += ' Under 25 lamps: availability on request before you pay.';
      var quote = p && p.status === 'quote_required';
      outLink.textContent = quote ? 'Request a confirmed quote' : 'Build this setup';
      outLink.href = quote ? quoteUrl + '?lamps=' + n + '&stations=' + stations + '&tables=' + n : build + '?lamps=' + n + '&stations=' + stations + '#build';
    }
    $$('[data-hl-step]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10);
        input.value = Math.min(10000, Math.max(1, (v >= 0 ? v : 0) + (+b.getAttribute('data-hl-step'))));
        render();
      });
    });
    input.addEventListener('input', render);
    render();
  }

  /* Quote form (V3): pre-fill the setup from the builder (?lamps=&stations=&existing=&logo=&tables=), availability
     mode (?mode=availability), optional estimate from the simulator, clear field errors, and a request reference. */
  function initQuote() {
    var form = $('[data-hl-quote-form]');
    if (!form) return;
    var q = new URLSearchParams(location.search);
    var store = window.sessionStorage;
    var copy = {};
    try { copy = JSON.parse($('[data-hl-quote-copy]', form.closest('section')).textContent); } catch (e) {}
    var avail = q.get('mode') === 'availability';
    function int(v) { return /^\d{1,5}$/.test(v || '') ? String(parseInt(v, 10)) : ''; }
    var lamps = int(q.get('lamps')), stations = int(q.get('stations')), existing = int(q.get('existing')), tables = int(q.get('tables') || q.get('kit'));
    var logo = q.get('logo') === '1';
    var filled = false;
    function put(sel, v) { var el = $(sel, form); if (el && v !== '' && !el.value) { el.value = v; filled = true; } }
    put('#hlq-lamps', lamps); put('#hlq-stations', stations); put('#hlq-tables', tables || lamps);
    var type = $('[data-hl-type]', form);
    if (type && !type.value) {
      var t = avail || (lamps && +lamps < 25) ? 'Fewer than 25 lamps' : (lamps && +lamps >= 1000) || (stations && +stations >= 1000) ? 'A large setup (1,000+ lamps)' : '';
      if (t) { type.value = t; filled = true; }
    }
    var setupField = $('[data-hl-setup-field]', form);
    if (setupField && lamps) {
      setupField.disabled = false;
      setupField.value = lamps + ' lamps · ' + (stations || '0') + ' new stations' + (existing ? ' · ' + existing + ' compatible stations already owned' : '') + (logo ? ' · logo on lamps' : '');
    }
    var prefill = $('[data-hl-prefill]', form);
    if (prefill && filled) prefill.hidden = false;
    if (avail) {
      var name = $('[data-hl-form-name]', form), btn = $('[data-hl-submit]', form);
      if (name && name.getAttribute('data-avail')) name.value = name.getAttribute('data-avail');
      if (btn && btn.getAttribute('data-avail')) btn.textContent = btn.getAttribute('data-avail');
      var hero = document.querySelector('.hl-hero');
      if (hero && copy.heading) {
        var h = hero.querySelector('.hl-h1'), p = hero.querySelector('.hl-lead');
        if (h) h.textContent = copy.heading;
        if (p && copy.text) p.textContent = copy.text;
      }
    }
    // Estimate from the simulator: attached only while the box stays ticked.
    var est = null;
    try { est = q.get('estimate') === '1' && store ? store.getItem('hl_estimate') : null; } catch (e) {}
    var estBox = $('[data-hl-estimate-box]', form);
    if (est && estBox) {
      estBox.hidden = false;
      var estField = $('[data-hl-estimate-field]', form), estCheck = $('[data-hl-estimate-check]', form);
      estField.value = est;
      var syncEst = function () { estField.disabled = !estCheck.checked; };
      estCheck.addEventListener('change', syncEst);
      syncEst();
    }
    var ref = $('[data-hl-ref]', form);
    var sent = $('[data-hl-sent]', form);
    if (sent) {
      var out = $('[data-hl-ref-out]', sent);
      try {
        var r = store && store.getItem('hl_ref');
        if (r && out) out.textContent = 'Your reference: ' + r + '.';
        if (store && store.getItem('hl_avail') === '1' && copy.ok) { var ok = $('[data-hl-ok-text]', sent); if (ok) ok.textContent = copy.ok; }
        if (store) { store.removeItem('hl_estimate'); store.removeItem('hl_avail'); }
      } catch (e) {}
      sent.focus();
      return;
    }
    function fieldError(el, msg) {
      var e = el.getAttribute('aria-describedby') && document.getElementById(el.id + '-err');
      if (e) e.textContent = msg || '';
      el.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }
    function check(el) {
      var v = String(el.value).trim(), msg = '';
      if (el.required && !v) msg = 'Please fill in this field.';
      else if (el.type === 'email' && v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) msg = 'Enter a valid email address.';
      else if (el.hasAttribute('data-hl-int') && v && !/^\d+$/.test(v.replace(/,/g, ''))) msg = 'Enter a whole number.';
      else if (el.hasAttribute('data-hl-int') && v && !el.hasAttribute('data-min') && +v.replace(/,/g, '') < 1) msg = 'Enter a whole number.';
      fieldError(el, msg);
      return !msg;
    }
    $$('input[required], input[data-hl-int]', form).forEach(function (el) { el.addEventListener('blur', function () { check(el); }); });
    form.addEventListener('submit', function (e) {
      var bad = $$('input[required], input[data-hl-int]', form).filter(function (el) { return !check(el); });
      if (bad.length) { e.preventDefault(); bad[0].focus(); return; }
      var d = new Date();
      var r = 'HL-' + String(d.getFullYear()).slice(2) + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2) + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
      if (ref) ref.value = r;
      try { store && store.setItem('hl_ref', r); if (avail) store.setItem('hl_avail', '1'); } catch (e2) {}
    });
  }

  /* Real venues: the <video> is built on the first click (nothing downloads before), with the block's WebVTT captions
     turned on; starting one video pauses the others. */
  function initRealVenues() {
    $$('[data-hl-rv-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var media = btn.closest('[data-hl-rv-media]');
        if (!media || !media.getAttribute('data-src')) return;
        var video = $('video', media);
        if (!video) {
          video = document.createElement('video');
          video.controls = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.preload = 'auto';
          var source = document.createElement('source');
          source.src = media.getAttribute('data-src');
          source.type = media.getAttribute('data-type') || 'video/mp4';
          video.appendChild(source);
          var vtt = $('[data-hl-rv-vtt]', media);
          if (vtt && window.Blob && window.URL) {
            var track = document.createElement('track');
            track.kind = 'subtitles';
            track.srclang = 'en';
            track.label = 'English';
            track.default = true;
            track.src = URL.createObjectURL(new Blob([vtt.textContent.replace(/<\\\//g, '</').trim()], { type: 'text/vtt' }));
            video.appendChild(track);
            video.addEventListener('loadedmetadata', function () { if (video.textTracks[0]) video.textTracks[0].mode = 'showing'; });
          }
          video.addEventListener('play', function () {
            $$('[data-hl-rv-media] video').forEach(function (other) { if (other !== video) other.pause(); });
          });
          media.appendChild(video);
        }
        media.classList.add('is-playing');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        video.focus();
      });
    });
  }

  /* V4: "show more" reviews, and silent loops that only play while visible (saves data on mobile). */
  function initReviews() {
    var sec = $('.hl-rev2') || $('.hl-rev');
    if (!sec) return;
    var btn = $('[data-hl-rev-more]', sec);
    if (btn) btn.addEventListener('click', function () { sec.classList.add('is-open'); btn.hidden = true; });
    var bar = $('[data-hl-rev-filters]', sec);
    if (!bar) return;
    var cards = $$('.hl-rev2__card', sec);
    $$('button', bar).forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-f');
        $$('button', bar).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        cards.forEach(function (c) {
          var show = f === 'all' || (f === 'video' ? c.getAttribute('data-src') === 'video' : c.getAttribute('data-role') === f);
          c.classList.toggle('is-out', !show);
        });
        sec.classList.toggle('is-filtered', f !== 'all');
        if (btn) btn.hidden = f !== 'all' || sec.classList.contains('is-open');
      });
    });
  }
  function initLoops() {
    var vids = $$('[data-hl-lazyloop], [data-hl-gallery] video[autoplay]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && !reduced) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* Windows has no colour flag emojis (it shows "NL", "IE"…): swap them for Twemoji images there only. */
  function initFlags() {
    if (!/Windows/.test(navigator.userAgent)) return;
    var re = /([\uD83C][\uDDE6-\uDDFF]){2}/g;
    $$('[data-hl-flags]').forEach(function (box) {
      var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) if (/([\uD83C][\uDDE6-\uDDFF]){2}/.test(walker.currentNode.nodeValue)) nodes.push(walker.currentNode);
      nodes.forEach(function (n) {
        var span = document.createElement('span');
        span.innerHTML = n.nodeValue.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(re, function (m) {
          var cps = Array.from(m).map(function (c) { return c.codePointAt(0).toString(16); }).join('-');
          return '<img class="hl-flag" src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/' + cps + '.svg" alt="" width="18" height="18" loading="lazy">';
        });
        n.parentNode.replaceChild(span, n);
      });
    });
  }

  function start() { initHeader(); initMenu(); initReveal(); initGallery(); initConfigurator(); initSizer(); initQuote(); initRealVenues(); initReviews(); initLoops(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
